<template>
  <div>
    <section class="section section-lg section-shaped overflow-hidden my-0">
      <div class="shape shape-style-1 shape-dark shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container py-3 pb-lg">
        <div class="row justify-content-between align-items-center">
          <div class="col-lg-5 mb-5 mb-lg-0">
            <h1 class="text-white">The Morgue</h1>
            <p class="lead text-white mt-4">{{intro}}</p>
            <base-button tag="a"
                         v-on:click="tracker('Booking', 'Redirected to booking', 'Morgue page info - top')"
                         href="https://offthecouch.io/book/otc" type="white" class="mt-4">
              Book now
            </base-button>
          </div>
          <div class="col-lg-6 mt-5 mb-lg-auto">
            <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
              <b-carousel id="carousel1"
                          controls
                          indicators>
                <!-- Text slides with image -->
                <b-carousel-slide img-src="img/brand/asheville/morgue/m2.jpg"></b-carousel-slide>
                <b-carousel-slide img-src="img/brand/asheville/morgue/m3.jpg"></b-carousel-slide>
                <b-carousel-slide img-src="img/brand/asheville/morgue/m1.jpg"></b-carousel-slide>
              </b-carousel>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="games" class="section section-lg pt-lg-0 mt--150">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-12">
                <div class="card white shadow border-0">
                  <img v-lazy="'img/brand/asheville/morgue/m2.jpg'" class="card-img-top fixed-height">
                </div>
                <card class="border-0" shadow>
                  <div class="row ml-2">
                    <div class="mb-4 d-flex align-right">
                      <icon name="ni ni-single-02" class="bg-gradient-white" color="default" shadow rounded></icon>
                      <span class="mt-3 ml-3 mr-5 text-dark text-uppercase font-weight-bold">{{players}}</span>
                    </div>
                    <!--                                        <div class="mb-4 d-flex align-right">-->
                    <!--                                            <icon name="ni ni-trophy" class="bg-gradient-white" color="warning" shadow rounded></icon>-->
                    <!--                                            <span class="mt-3 mr-4 ml-3 text-dark text-uppercase font-weight-bold">{{difficulty}}</span>-->

                    <!--                                        </div>-->
                    <div class="mb-4 d-flex align-right">
                      <icon name="ni ni-time-alarm" class="bg-gradient-white" color="default" shadow rounded></icon>
                      <span class="mt-3 ml-3 text-dark text-uppercase font-weight-bold">{{duration}}</span>
                    </div>
                  </div>
                  <h4 class="mt-2 text-dark">Chapter 3: The Morgue</h4>
                  <p class="mt-2">{{description}}</p>
                  <p class=" text-dark text-uppercase font-weight-bold">{{disclaimer6}}</p>
                  <p class="mt-3">
                    <span class=" text-dark text-uppercase font-weight-bold">{{disclaimer}}</span>
                    {{disclaimer2}}

                  </p>
                  <p class="mt-3">
                    <span class=" text-dark text-uppercase font-weight-bold">{{disclaimer4}}</span>
                    {{disclaimer5}}
                  </p>
                  <p>
                    <strong>{{disclaimer3}}</strong>
                  </p>
                  <base-button tag="a"
                               v-on:click="tracker('Booking', 'Redirected to booking', 'Art Gallery page info - bottom')"
                               href="https://offthecouch.io/book/otc" type="white" class="mt-2 mb-2">
                    Book now
                  </base-button>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";
export default {
  name: "Gallery",
  components: {BCarousel, BCarouselSlide},
  data () {
    return {
      description: "The man you have been hunting continues to evade you and this time he sends you to the Morgue where he wants to play a little game.  Will you be able to come out alive or join the rest of the bodies at this abandoned Morgue?",
      disclaimer: "ALL BOOKINGS ARE PRIVATE. ",
      disclaimer2: "Only your group will be in the game.",
      disclaimer3: "This is the third of twelve chapters, with each chapter ranging in length from 120-180 minutes.  If you would like to book more than 2 hours, please contact us.",
      disclaimer4: "GAME IS NOT SUITABLE FOR CHILDREN, ",
      disclaimer5: "please contact us if you have any questions.",
      disclaimer6: "HIGHLY RECOMMENDED YOU PLAY CHAPTER 2: NORCROSS ART GALLERY BEFORE PLAYING THIS CHAPTER.",
      players: "2-6",
      difficulty: "Difficult",
      duration: "120-180 minutes",
      intro: "You are forced to go to the Morgue to play a game of life and death with the Evil Genius."
    }
  },
  methods: {
    tracker(category, action, label) {
      this.$ga.event(category, action, label)
    }
  }
}
</script>

<style scoped>
.fixed-height{
  width: 100%; /* width of container */
  height: 300px; /* height of container */
  object-fit: cover;
}
</style>
